export default __webpack_public_path__ + "static/media/Curvetblank.26209883.svg";